import { render, staticRenderFns } from "./channel-detail-block.vue?vue&type=template&id=b69f4eec&scoped=true"
import script from "./channel-detail-block.vue?vue&type=script&setup=true&lang=js"
export * from "./channel-detail-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel-detail-block.vue?vue&type=style&index=0&id=b69f4eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69f4eec",
  null
  
)

export default component.exports